import { useState, useEffect } from "react";

type configType = {
  persist: boolean;
};
const useLocalStorage = (key: string, defaultValue: any = {}, config: configType = { persist: true }) => {
  const [value, setValue] = useState<any>(defaultValue);

  const loadStorage = () => {
    let item: string = localStorage.getItem(key);
    if (item) {
      try {
        item = JSON.parse(item);
      } catch (e) {}
      setValue(item);
    } else {
      setValue(defaultValue);
    }
  };
  const watchStorage = (event) => {
    if (event.key === key) {
      loadStorage();
    }
  };
  useEffect(() => {
    loadStorage();
    window.addEventListener("storage", watchStorage);
    return () => window.removeEventListener("storage", watchStorage);
  }, []);

  useEffect(() => {
    if (value !== defaultValue && config.persist) {
      let item = value;
      if (typeof value !== "string" && typeof value !== "number") {
        item = JSON.stringify(value);
      }
      localStorage.setItem(key, item);
    }
  }, [value]);

  return [value, setValue];
};

export default useLocalStorage;
